import './login-form.css'
import {Field, reduxForm} from "redux-form";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {getProfile} from "../../redux/profile-reducer";
import {Link, Redirect} from "react-router-dom";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const isLoginSelector = (state) => state.profilePage.isLogin;
const isErrorSelector = (state) => state.profilePage.isError;
const isErrorTextSelector = (state) => state.profilePage.errorText;

const LoginForm = () => {
    const dispatch = useDispatch();
    const errorText= useSelector(isErrorTextSelector)
    const isError= useSelector(isErrorSelector);
    const isLogin = useSelector(isLoginSelector);
    const onSubmit = (formData) => {
        dispatch(getProfile(formData.email, formData.password, formData.rememberMe));
    }
    if (isLogin) {
        return <Redirect to={"/profile"}/>
    }
    if(isError){
        toast.error(errorText)
    }
    return (
        <div className="container">
            <div className="row text-center">
                <div className="panel panel-primary col-12 col-md-6 col-xl-4">
                    <div className="panel-body">
                        <ToastContainer/>
                        <LoginReduxForm onSubmit={onSubmit}/>
                    </div>
                </div>
            </div>
        </div>

    )
};

const LoginFormInputs = (props) => {
    return (
        <form onSubmit={props.handleSubmit}>
            <div className="form-group">
                <h2>LOGIN</h2>
            </div>
            <div className="form-group">
                <label className="control-label">Email</label>
                <Field name="email" type="email" maxLength="50" className="form-control"
                       placeholder="Enter email"
                       component={"input"}/>
            </div>
            <div className="form-group">
                <label className="control-label">Password</label>
                <Field name="password" type="password" maxLength="25" className="form-control"
                       placeholder="Enter your password" length="40" component={"input"}/>
            </div>
            <div className="form-group">
                <Field name="rememberMe" type={"checkbox"} component={"input"}/> remember me
            </div>
            <div className="form-group">
                <button className="btn btn-info btn-block">Sign in</button>
            </div>
            <p className="form-group">By creating an account, you agree to our <a href="#">Terms of
                Use</a> and our <a href="#">Privacy Policy</a>.</p>

            <p>Already have an account? <Link to="/registration">Sign up</Link></p>
        </form>
    )
}

const LoginReduxForm = reduxForm({
    form: 'login'
})(LoginFormInputs);
export default LoginForm;

// const LoginReduxForm = reduxForm({
//     form: 'login'
// })(LoginFormInputs);
// const mapStateToProps = (state) => ({
//     isLogin: state.profilePage.isLogin
// })
// const mapDispatchToProps = dispatch => {
//     return {
//         getProfile: (email, password,rememberMe) => dispatch(getProfile(email, password,rememberMe)),
//     }
// }
// export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);